import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import CompanySidebar from './CompanySidebar';
import CompanyHeader from './CompanyHeader';

interface CompanyLayoutProps {
  children?: React.ReactNode;
}

/**
 * Main company dashboard layout component
 * Matches the structure and styling of candidate DashboardLayout
 */
const CompanyLayout: React.FC<CompanyLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F8F9FB]" style={{ fontFamily: 'Manrope, sans-serif' }}>
      {/* Sidebar */}
      <CompanySidebar
        isCollapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        isMobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />

      {/* Main Content Area */}
      <div className={`
        transition-all duration-300 p-4 lg:p-8
        ${sidebarCollapsed ? 'lg:ml-[100px]' : 'lg:ml-[280px]'}
      `}>
        {/* Mobile Menu Button */}
        <div className="lg:hidden mb-4">
          <button
            onClick={() => setMobileSidebarOpen(true)}
            className="w-10 h-10 rounded-xl bg-white flex items-center justify-center hover:bg-gray-50 shadow-sm border border-gray-100 transition-colors"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#0B111E]">
              <line x1="4" x2="20" y1="12" y2="12" />
              <line x1="4" x2="20" y1="6" y2="6" />
              <line x1="4" x2="20" y1="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Top Header */}
        <CompanyHeader />

        {/* Page Content */}
        <main className="animate-fade-in-up">
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
};

export default CompanyLayout;
